import { Middleware } from '@nuxt/types'
import { OwnerDetailActions, OwnerDetailModuleState } from '~/store/owner/detail'
import { OwnerBillingVersion } from '~/types/types'

/**
 * Middleware that restricts access to pages requiring unified billing (V2).
 * Returns a 404 error if the owner is not on unified billing.
 */
const unifiedBillingOnly: Middleware = async ({ store, route, error }) => {
  const { provider, owner: login } = route.params

  if (login && provider) {
    await store.dispatch(`owner/detail/${OwnerDetailActions.FETCH_OWNER_DETAILS}`, {
      provider,
      login
    })

    const { owner } = store.state.owner.detail as OwnerDetailModuleState
    if (owner?.billingVersion !== OwnerBillingVersion.V2) {
      error({ statusCode: 404 })
    }
  }
}

export default unifiedBillingOnly
